import { useCallback, useState } from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import messages from '../pages/Exposures/ExposuresPage.messages';

export default ({
    ownerVM
}) => {
    const [, updateState] = useState();
    const { showConfirm } = useModal();

    const addExposure = useCallback(
        (callbackProps) => {
            const { path } = callbackProps;
            const exposures = _.get(ownerVM, `${path}.value`);
            if (exposures) {
                exposures.push({});
                _.set(ownerVM, `${path}.value`, exposures);
            } else {
                _.set(ownerVM, path, {});
                _.set(ownerVM, `${path}.value`, [{}]);
            }
            updateState({});
        },
        [ownerVM]
    );

    const deleteExposure = useCallback(
        (callbackProps) => {
            const {
                path, iterableIndex, modalTitle, modalMessage
            } = callbackProps;

            showConfirm({
                title: modalTitle,
                message: modalMessage,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.removeActionLabel
            }).then(async (results) => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }
                // everything up to children
                const exposuresPath = path.substring(0, path.lastIndexOf('.children'));
                const exposures = _.get(ownerVM, `${exposuresPath}.value`);
                exposures.splice(iterableIndex, 1);
                updateState({});
            }, _.noop);
        },
        [ownerVM, showConfirm]
    );

    return {
        addExposure,
        deleteExposure
    };
};
